import * as React from 'react';

import {
  AlignItems,
  Body1,
  Body2,
  Box,
  Col,
  Color,
  Display,
  FlexDirection,
  Grid,
  Icon,
  IconVariant,
  Space,
} from '@gousto-internal/citrus-react';

import { SectionHeading } from '../SectionHeading';
import { Pill } from '../Pill';
import { GetStartedCTA } from '../GetStartedCTA';

const VARIETY_PILLS_CONTENT = [
  'Vegetarian',
  'Vegan',
  'Gluten-free',
  'Dairy-free',
  'Healthy choices',
  'Family classics',
  'Quick & easy',
  'Global cuisines',
];

export function EndlessVarietySection({
  ctaHref,
  mobileHiddenCta,
  ctaOnClick,
  recipesAvailableThisMonth = null,
}: {
  ctaHref?: string | null;
  mobileHiddenCta?: boolean;
  ctaOnClick?: () => void;
  recipesAvailableThisMonth?: number | null;
} = {}) {
  return (
    <section aria-labelledby="endless-variety-heading">
      <Box
        display={Display.Flex}
        flexDirection={FlexDirection.Column}
        alignItems={[AlignItems.FlexStart, null, AlignItems.Center]}
        paddingV={[14, null, 16]}
        paddingH={[4, null, null, 10]}
      >
        <SectionHeading color={Color.Primary_600} id="endless-variety-heading">
          Endless variety
        </SectionHeading>

        <Space size={5} />

        <Body1 color={Color.ColdGrey_800}>
          Discover over{recipesAvailableThisMonth !== null ? ` ${recipesAvailableThisMonth}` : ''}{' '}
          recipes a month with new releases every Tuesday
        </Body1>

        <Space size={[4, null, 3]} />

        <Grid width="100%" maxWidth="800px" gap={2}>
          {VARIETY_PILLS_CONTENT.map((pillContent) => {
            return (
              <Col key={pillContent} size={[6, null, 3]}>
                <Pill width="100%">
                  <Box display={Display.Flex} gap={1} alignItems={AlignItems.Center}>
                    <Box display={Display.Flex} color={Color.Success_400}>
                      <Icon variant={IconVariant.Inherit} name="tick" />
                    </Box>
                    <Body2 color={Color.ColdGrey_800}>{pillContent}</Body2>
                  </Box>
                </Pill>
              </Col>
            );
          })}
        </Grid>

        <Space size={[4, null, 3]} />

        <GetStartedCTA href={ctaHref} mobileHidden={mobileHiddenCta} onClick={ctaOnClick} />
      </Box>
    </section>
  );
}
